module.exports = __webpack_public_path__ + "img/phillips-smart-led.2d16c8b1.jpg";